module.exports = __webpack_public_path__ + "h5/img/telss.8812ed0a.png";